import Vue from 'vue';

// layout
import UiPage from './layout/UiPage'

// containers
import UiCard from './containers/UiCard'
import UiCardInsight from './containers/UiCardInsight'

// controls
import UiTimePicker from './controls/UiTimePicker'
import UiDayFilter from './controls/UiDayFilter'
import UiDropdown from './controls/UiDropdown'
import UiCopyButton from './controls/UiCopyButton'

// layout
Vue.component('ui-page', UiPage);

// containers
Vue.component('ui-card', UiCard);
Vue.component('ui-card-insight', UiCardInsight);

// controls
Vue.component('ui-time-picker', UiTimePicker);
Vue.component('ui-day-filter', UiDayFilter);
Vue.component('ui-dropdown', UiDropdown);
Vue.component('ui-copy-button', UiCopyButton);
